<template>
  <q-layout view="hHh lpR fFf">
    <!-- Górny pasek -->
    <q-header elevated class="bg-primary text-white">
      <q-toolbar class="q-px-md">
        <q-toolbar-title class="text-h6">Aplikacja</q-toolbar-title>
        <q-space />
        <template v-if="!userStore.isLoggedIn">
          <q-btn flat label="Zaloguj się" @click="router.push('/login')" />
          <q-btn flat label="Zarejestruj się" @click="router.push('/register')" />
        </template>
      </q-toolbar>
    </q-header>

    <!-- Zawartość strony -->
    <q-page-container class="bg-grey-2">
      <router-view />
    </q-page-container>

    <!-- Stopka -->
    <q-footer class="text-center q-pa-sm text-white-7">
      <div>&copy; 2025 Lektorzy.app</div>
      <div>Parafia Newcastle</div>
    </q-footer>
  </q-layout>
</template>

<script setup lang="ts">
import { useUserStore } from 'src/stores/userStore';
import { useRouter } from 'vue-router';
import { onMounted } from 'vue';
import { setupAuthStateListener } from 'src/utils/authStateListener';

const userStore = useUserStore();
const router = useRouter();

onMounted(() => {
  setupAuthStateListener();
});
</script>
